<template>
  <v-app class="userpg" v-bind:class="{ xsOnly: $vuetify.breakpoint.xsOnly }">
    <v-content>
      <v-container fill-height >
        <v-layout align-center>
          <v-flex>
            <div class="h-hold text-xs-center">
              <a class="h-logohold" href="https://tryworktabs.com">
                <div class="h-logo"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 255.21 255.12"><title>Logo</title><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><rect class="line" width="28.35" height="255.12"/><rect class="line" x="57.09" width="28.35" height="255.12"/><rect class="line" x="114.18" width="28.35" height="255.12"/><rect class="line" x="169.77" width="28.35" height="255.12"/><rect class="line" x="226.86" width="28.35" height="255.12"/></g></g></svg></div>
                <span class="logo-text">Worktabs</span>
              </a>
            <v-layout row v-if="error">
              <v-flex xs12>
                <app-alert @dismissed="onDismissed" :text="error.message"></app-alert>
              </v-flex>
            </v-layout>
            <div class="entrycard mb-4">
            <h1>Begin your 14 day free trial</h1>
              <form @submit.prevent="onSignup">
                    <v-text-field
                    name="email"
                    id="email"
                    placeholder=" "
                    v-model="email"
                    type="email"
                    label="Your email"
                    required>
                    </v-text-field>
                    <v-text-field
                    name="password"
                    id="password"
                    placeholder=" "
                    v-model="password"
                    type="password"
                    label="Password"
                    class="mt-4"
                    required>
                    </v-text-field>
                    <v-text-field
                    name="confirmPassword"
                    id="confirmPassword"
                    placeholder=" "
                    v-model="confirmPassword"
                    type="password"
                    label="Confirm password"
                    class="mt-4"
                    :rules="[comparePasswords]">
                    </v-text-field>
                  <v-btn class="mt-4 mb-2" block large depressed color="primary" type="submit" :disabled="loading" :loading="loading">
                      <span class="body-2">Continue</span>
                      <span slot="loader" class="custom-loader">
                        <v-icon light>cached</v-icon>
                      </span>
                    </v-btn>
              </form>
              </div>
              <p class="account-link pt-2 text-dark--text body text-xs-center">Already have an account? <span style="cursor:pointer;" @click="goToSignin()" class="mutedprimary--text pr-2">Sign In</span></p>
              <p class="account-link pt-2 text-dark--text body text-xs-center"><a href="https://tryworktabs.com/terms/" target="blank" class="mutedprimary--text">Privacy policy</a></p>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>

export default {
  data () {
    return {
      email: this.$route.query.email,
      password: '',
      confirmPassword: '',
      groupTitle: '',
      currencyCode: 'GBP',
      currencySymbol: '£',
      countryCode: 'GB',
      countryName: 'United Kingdom',
      regionCode: 'SCT',
      regionName: 'Scotland',
      // maybe in future at some point
      // timezone: Intl.DateTimeFormat().resolvedOptions().timeZone
      // for now use the ipdata
      timezone: 'Europe/London',
      chargeTax: false,
      taxCalcInclusive: false,
      displayWithTax: false
    }
  },
  watch: {
    user (value) {
      if (value !== null && value !== undefined) {
        console.log('going to /')
        setTimeout(() => this.$router.push({ name: 'Board' }).catch(() => {}), 20)
      }
    }
  },
  computed: {
    comparePasswords () {
      return this.password !== this.confirmPassword ? 'Passwords do not match' : true
    },
    user () {
      return this.$store.getters.user
    },
    error () {
      return this.$store.getters.error
    },
    loading () {
      return this.$store.getters.loading
    },
    language () {
      return navigator.language
    }
  },
  methods: {
    onSignup () {
      this.$store.dispatch('signUserUp', {
        email: this.email,
        password: this.password,
        groupTitle: this.groupTitle,
        cur: this.currencyCode,
        symbol: this.currencySymbol,
        tz: this.timezone,
        lang: this.language,
        cntc: this.countryCode,
        cntn: this.countryName,
        rgnc: this.regionCode,
        rgnn: this.regionName,
        chargeTax: this.chargeTax,
        taxCalcInclusive: this.taxCalcInclusive,
        displayWithTax: this.displayWithTax
      })
    },
    goToSignin () {
      this.$store.commit('clearError')
      this.$router.push('/sign-in')
    },
    onDismissed () {
      this.$store.dispatch('clearError')
    },
    fetchIpData () {
      // get currency code from ipdata and use to suggest default currency
      fetch('https://api.ipdata.co/?api-key=a8ca6bc0369e63d6016759de3d1d830ebe33965fedb7891347f39544')
        .then(response => {
          return response.json()
        })
        .then(myJson => {
          if (myJson.country_code) {
            this.currencyCode = myJson.currency.code
            this.currencySymbol = myJson.currency.symbol
            this.countryCode = myJson.country_code
            this.countryName = myJson.country_name
            this.regionCode = myJson.region_code
            this.regionName = myJson.region
            this.timezone = myJson.time_zone.name
          } else {
            console.log('no')
          }
        })
    }
  },
  created () {
    this.fetchIpData()
  }

}
</script>
